import {
  FormEventHandler,
  forwardRef,
  memo,
  Ref,
  useImperativeHandle,
  useRef,
} from "react";
import * as inputCss from "./input.module.css";

export interface HiddenInputHandle {
  focus(): void;
}

export const HiddenInput = memo(
  forwardRef(function HiddenInput(
    { onSubmit }: { onSubmit: (value: string) => void },
    ref: Ref<HiddenInputHandle>,
  ) {
    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => ({
      focus() {
        if (!inputRef.current) {
          return;
        }
        inputRef.current.value = "";
        inputRef.current.focus();
      },
    }));
    const handleSubmit: FormEventHandler = (event) => {
      event.preventDefault();
      if (!inputRef.current) {
        return;
      }
      onSubmit(inputRef.current.value);
      inputRef.current.value = "";
    };
    return (
      <form className={inputCss.hidden} onSubmit={handleSubmit}>
        <input ref={inputRef} type="text" />
      </form>
    );
  }),
);
